import Vue from 'vue'
import Router from 'vue-router'

import PageBingo from '@/pages/page-bingo'
import PageBingoIndex from '@/pages/page-bingo-index'

Vue.use(Router)

export default new Router({
  // mode: 'history', // causes issues in iOS 13 as PWA

  routes: [
    {
      path: '/bingo/:id',
      name: 'bingo.show',
      component: PageBingo,
      props: true
    },
    {
      path: '/bingo',
      name: 'bingo.index',
      component: PageBingoIndex,
    },
    {
      path: '/',
      redirect: '/bingo'
    }
  ]
})
